export default __webpack_public_path__ + "static/media/pescaTtsIt_It60.4c52ea35.mp3";